<template>
  <pop-up-layout
      :title="localization.modificarEstado"
      :loading="waitingForLoad"
      :aceptar="localization.guardar"
      :saving="waitingForLoad"
      :disabled="!cambiado"
      @aceptar="guardar()"
      @volver="$parent.hide()"
    >
    <v-form v-model="valid" id="valid" ref="form">
      <v-row justify="center">
        <v-col cols="8">
          <v-layout wrap justify-center>
            <v-flex xs12 sm12 md12 lg12 pl-1 pr-1>
              <v-autocomplete :no-data-text="$t('sinDatos')" v-model="statusIdSelected" id="statusIdSelected" :items="estados" item-text="name"
                item-value="id" :label="localization.estados" :rules="[rules.obligatorio]">
                <template v-slot:selection="data">
                  {{ data.item.code }} - {{ data.item.translates[usuario.idioma] }}
                </template>
                <template v-slot:item="data">
                  {{ data.item.code }} - {{ data.item.translates[usuario.idioma] }}
                </template>
              </v-autocomplete>
            </v-flex>
          </v-layout>
          <v-menu v-model="datePickerMenu" id="datePickerMenu" :close-on-content-click="false"
            :nudge-right="40" transition="scale-transition"
            offset-y min-width="290px">
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="statusDateFormated" id="statusDateFormated"
                :label="localization.fecha"
                prepend-icon="event"
                :rules="[rules.date]"
                v-on="on"
                v-on:keypress="evitarKeyPress($event)"
              />
            </template>
            <v-date-picker v-model="statusDate" id="statusDate" @input="datePickerMenu = false" locale="es"/>
          </v-menu>
          <v-menu v-if="getCierreSelected" v-model="finishDatePickerMenu" id="finishDatePickerMenu" :close-on-content-click="false"
            :nudge-right="40" transition="scale-transition"
            offset-y min-width="290px">
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="statusFinishDateFormated" id="statusFinishDateFormated"
                :label="localization.fechaFinReal"
                prepend-icon="event"
                :rules="[rules.date]"
                v-on="on"
              />
            </template>
            <v-date-picker v-model="finishDate" id="finishDate" @input="finishDatePickerMenu = false" locale="es"/>
          </v-menu>
          <v-checkbox v-if="getCierreSelected" v-model="vistoBueno" id="vistoBueno" color="primary" :label="$t('vistoBuenoCliente')"/>
          <v-row v-if="getCierreSelected">
            <v-col cols="12" class="py-0">
              <h3 class="primary--text text-uppercase text-start">
                {{$t('datosIncidencia.datosClienteCierre.titulo')}}
              </h3>
            </v-col>
            <v-col cols="7" class="py-0">
              <v-text-field
                :label="$t('datosIncidencia.datosClienteCierre.nombre')"
                v-model="nombreClienteCierre" id="nombreClienteCierre"
                :rules="[]"
              />
            </v-col>
            <v-col cols="5" class="py-0">
              <v-text-field
                :label="$t('datosIncidencia.datosClienteCierre.nif')"
                v-model="nifClienteCierre" id="nifClienteCierre"
                :rules="[]"
              />
            </v-col>
          </v-row>
          <v-file-input
            label=""
            filled
            v-model="image" id="image"
            prepend-icon="attach_file"
          />
          <v-text-field v-model="fileDesc" id="fileDesc" :label="localization.descripcion" :rules="[rules.obligatorio, rules.max(100)]" v-if="this.image"/>
          <v-text-field v-model="observaciones" id="observaciones" :label="localization.observaciones" autocomplete="disabled" :rules="[rules.obligatorio]"/>
        </v-col>
      </v-row>
    </v-form>
  </pop-up-layout>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import rulesMixin from '@/components/generic/rules.js'
import moment from 'moment'

export default {
  mixins: [rulesMixin],
  props: {
    incidenceIds: Array,
    singleItem: Array,
    estadoOrigen: String
  },
  data () {
    return {
      image: null,
      fileDesc: '',
      statusIdSelected: '',
      observaciones: '',
      nombreClienteCierre: '',
      nifClienteCierre: '',
      statusDate: new Date().toISOString().substr(0, 10),
      finishDate: null,
      datePickerMenu: false,
      finishDatePickerMenu: false,
      arrImageSplit: null,
      vistoBueno: false,
      waitingForLoad: false,
      cambiado: false,
      valid: true
    }
  },
  computed: {
    ...mapGetters({
      configuracionStore: 'configuracion/getConfiguracion',
      rolProveedor: 'login/rolProveedor',
      idubapi: 'login/idubapi',
    }),
    configVistoBueno () {
      return this.$store.state.configuracion.configuracion.configVistoBuenoCliente
    },
    localization () {
      return this.$t('popUpCambiarEstado')
    },
    usuario() {
      return JSON.parse(localStorage.getItem('usuario'))
    },
    translates() {
      if (this.$store.state.tiposSolicitud.translates) {
        return this.$store.state.tiposSolicitud.translates;
      }
      return [];
    },
    estados () {
      let transitoLibreEstados = this.$store.state.configuracion.configuracion.transitoLibreEstados
      let estadosTodos = this.$store.state.incidencias.estados

      /*
      // siempre que esté disponible el estado visto bueno lo mostraremos como posible destino
      if (this.configVistoBueno === false) {
        // quitamos el estado 41
        estadosTodos = estadosTodos.filter(function( obj ) {
          return obj.code !== '41'
        });
        // estadosTodos.splice(4, 1)
      }
      */
      let rolProveedorGestonEstados = false
      if(this.rolProveedor){
        if(this.idubapi.PERMISOS_ROL_PROVEEDOR_WEB.GESTION_ESTADOS === "1" || this.idubapi.PERMISOS_ROL_PROVEEDOR_WEB.GESTION_ESTADOS === 1){
          rolProveedorGestonEstados = true
        }
      }
     
      let permisosExtraProveedor = this.$store.state.configuracion.configuracion.PV_PERMISOS_EXTRA_PROVEEDOR;
      let transitoEstadosProveedor = this.$store.state.configuracion.configuracion.PV_TRANSITO_ESTADOS_PROVEEDOR;

      if(this.rolProveedor && !rolProveedorGestonEstados) {

        // el proveedor solo puede pasar a estados 20 y 30
        var estadosDestino = estadosTodos.filter(obj => {
          return obj.code !== this.estadoOrigen && (obj.code == 20 || obj.code == 30)
        })
        
        if ( transitoEstadosProveedor ) {
          // El proveedor puede pasar del estado 20 - En proceso al 40 - Visto Bueno Técnico
          if (this.estadoOrigen == 20 && !estadosDestino.includes(40)) {
              estadosDestino.push(estadosTodos.find(obj => obj.code == 40))
          }
        }

        return estadosDestino
      } else {
        if (transitoLibreEstados) {
          return estadosTodos.filter(obj => {
            return obj.code !== this.estadoOrigen
          })
        } else {
          // solo se puede transitar al anterior y al posterior
          let codigosEstados = estadosTodos.map(item => item.code)
          let posicion = codigosEstados.indexOf(this.estadoOrigen)
          let origen = this.estadoOrigen
          let rechazadaIndex = ''
          let estadosDestino = []
          switch (posicion) {
            case 0:
              rechazadaIndex = codigosEstados.indexOf('90')
              estadosDestino = [estadosTodos[1], estadosTodos[rechazadaIndex]]
              break
            case codigosEstados.length - 1:
              estadosDestino = [estadosTodos[0]]
              break
            default:
              console.log('entro al default', estadosTodos[posicion - 1])
              if (origen === '50') {
                estadosDestino = [
                  estadosTodos[posicion - 1]
                ]
                break
              }
              estadosDestino = [
                estadosTodos[posicion - 1],
                estadosTodos[posicion + 1]
              ]
              break
          }
          
          if ( permisosExtraProveedor && transitoEstadosProveedor ) {
            // El proveedor puede pasar del estado 20 - En proceso al 40 - Visto Bueno Técnico
            if (this.estadoOrigen == 20 && !estadosDestino.includes(40)) {
                estadosDestino.push(estadosTodos.find(obj => obj.code == 40))
            }
          }
          return estadosDestino
        }
      }
    },
    selectedIds () {
      const ids = []
      if (this.incidenceIds) {
        this.incidenceIds.map(e => {
          ids.push(e.id)
        })
        return ids
      }
      return []
    },
    statusDateFormated () {
      return (this.statusDate) ? moment(this.statusDate, 'YYYY-MM-DD').format('DD/MM/YYYY') : null
    },
    statusFinishDateFormated () {
      return (this.finishDate) ? moment(this.finishDate, 'YYYY-MM-DD').format('DD/MM/YYYY') : null
    },
    getCierreSelected () {
      let cerrado = this.estados.find(x => x.code === '50')
      return cerrado ? this.statusIdSelected === cerrado.id : false
    }
  },
  methods: {
    ...mapActions({
      addAlert: 'alerts/add'
    }),
    close () {
      this.$emit('input')
    },
    guardar () {
      this.$refs.form.validate()
      if (!this.valid) {
        this.addAlert({texto: this.$t("revisarCamposRojo"), color: 'error'})
      } else {
        var objetoDocumentacion
        if(this.image) {
          objetoDocumentacion = {
            picture: this.arrImageSplit ? this.arrImageSplit[1] : '',
            name: this.image ? this.image.name : '',
            mime: this.image ? this.image.type : '',
            description: this.fileDesc.length > 1 ? this.fileDesc : 'Documentación',
            tipoObjectoId: '2',
            carpetaId: '4'
          }
        }

        let values = [{
          incidenceId: this.selectedIds.length > 0 ? this.selectedIds : this.singleItem,
          statusId: this.statusIdSelected,
          updateDate: this.statusDate,
          finishDate: this.finishDate,
          vb: this.vistoBueno ? '1' : '0',
          updateDescription: this.observaciones,
          documentacion: objetoDocumentacion
        }]

        if (this.getCierreSelected) {
          values[0].nombreClienteCierre = this.nombreClienteCierre
          values[0].nifClienteCierre = this.nifClienteCierre
        }

        console.log('VALUES MODIFICAR ESTADO: ', values)
        this.$emit('updateData', values)
        this.$parent.hide()
      }
    },
    checkImagen(image) {
      const retorno = image ? this.rules.validarFormatoImagen(image.type) : false
      return retorno
    },
    evitarKeyPress (event) {
      event.preventDefault()
    }
  },
  watch: {
    statusIdSelected () {
      this.cambiado = true
    },
    image () {
      if(this.image === null) return
      const file = this.image
      let reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = () => {
        let imageBase64 = reader.result
        this.arrImageSplit = imageBase64.split(',')
      }
    }
  }
}
</script>

<style scoped>

</style>
